import { useState } from "react";

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQContent {
  eyebrow: string;
  headline: string;
  items: FAQItem[];
}

interface Props {
  content: FAQContent;
}

export default function FAQSection({ content }: Props) {
  const { eyebrow, headline, items } = content;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16">
          {/* Left heading */}
          <div className="lg:col-span-2">
            <span className="section-eyebrow">{eyebrow}</span>
            <span className="gold-divider" />
            <h2 className="section-heading text-4xl md:text-5xl font-light mt-2 mb-4">
              {headline}
            </h2>
            <p className="font-sans text-sm text-charcoal/60 leading-relaxed">
              Answers to the most common questions about our lash extensions, hair services, and
              tanning in Lehi, Utah — structured for quick answers.
            </p>
          </div>

          {/* Right accordion */}
          <div className="lg:col-span-3 space-y-2">
            {items.map((item, i) => (
              <div
                key={i}
                className="border border-cream-dark hover:border-gold/30 transition-colors duration-200"
              >
                <button
                  className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left cursor-pointer group"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  aria-expanded={openIndex === i}
                >
                  <span
                    className={`font-sans text-sm font-medium transition-colors duration-200 ${
                      openIndex === i ? "text-gold" : "text-charcoal-dark group-hover:text-gold"
                    }`}
                  >
                    {item.question}
                  </span>
                  <span
                    className={`flex-shrink-0 w-5 h-5 flex items-center justify-center transition-transform duration-300 ${
                      openIndex === i ? "rotate-45" : ""
                    }`}
                  >
                    <i className={`text-gold text-sm ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`} />
                  </span>
                </button>
                <div
                  className={`accordion-content ${openIndex === i ? "open" : ""}`}
                >
                  {/* Gold accent left border when open */}
                  <div className="px-6 pb-5 border-l-2 border-gold ml-6">
                    <p className="font-sans text-sm text-charcoal/60 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
